import React, { Component } from "react";

class KishuSelector extends Component {
  onChangeKishu = (event) => {
    const json = event.target.selectedOptions[0].getAttribute("data-kishu")
      ? JSON.parse(event.target.selectedOptions[0].getAttribute("data-kishu"))
      : "";
    if (event.target.id === "maleSelect") {
      this.props.updateParent("dad", json);
    } else {
      this.props.updateParent("mom", json);
    }
  };

  render() {
    const renderSelect = (kishu, parent) => {
      var jsonData = require(`./kishu/${kishu}s.json`);
      const kishuOptions = jsonData.map((kishu, i) => {
        return (
          <option key={i++} value={kishu.id} data-kishu={JSON.stringify(kishu)}>
            {kishu.name}
          </option>
        );
      });

      return (
        <select
          id={`${kishu}Select`}
          className="form-select"
          onChange={this.onChangeKishu}
          value={kishu.id}
        >
          <option key="-1" value="" data-kishu="">
            Select Kishu
          </option>
          {kishuOptions}
        </select>
      );
    };
    return (
      <div className="row px-3 py-3">
        {renderSelect(this.props.gender, this.props.currParent)}
      </div>
    );
  }
}

export default KishuSelector;
